module.exports = {
  "version": "0.24.0"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/axios/lib/env/data.js
// module id = 402
// module chunks = 0